import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { currentBookingAtom, roundRestrictionsAtom } from "../../stores";

export const getRoundRestrictionsByRoundIdAtom = atomFamily(
  (roundId: string) => {
    return atom((get) => {
      const roundRestrictions = get(roundRestrictionsAtom);
      const booking = get(currentBookingAtom);
      const roundIndex = booking?.rounds.findIndex(
        (r) => r.localId === roundId
      );
      if (roundIndex === undefined) return null;
      const roundRestrictionsForRound = roundRestrictions[roundIndex];
      return roundRestrictionsForRound;
    });
  }
);
